import './TileStatus.css'
import { FormStatus, FormStatus_Status } from '@/api/brokers/v1/brokers_pb'

const STATUS_CONFIG = {
	[FormStatus_Status.UNSPECIFIED]: { className: 'tileStatusUnspecified', text: 'Non défini' },
	[FormStatus_Status.CANCELED]: { className: 'tileStatusCanceled', text: 'Annulé' },
	[FormStatus_Status.PENDING]: { className: 'tileStatusPending', text: 'En attente' },
	[FormStatus_Status.COMPLETED]: { className: 'tileStatusCompleted', text: 'Validé' },
} as const satisfies Record<FormStatus_Status, { className: string; text: string }>

// Type for the values
export type StatusDetails = (typeof STATUS_CONFIG)[keyof typeof STATUS_CONFIG]

interface TileStatusProps {
	status: FormStatus | undefined
}

export function TileStatus(props: TileStatusProps) {
	// Fallback to PENDING if status is unknown / undefined
	const details =
		(props.status != null ? STATUS_CONFIG[props.status.status] : undefined) ??
		STATUS_CONFIG[FormStatus_Status.PENDING]

	return <div className={`tileStatus ${details.className}`}>{details.text}</div>
}
